// eslint-disable-next-line import/no-cycle
import { IFilterObj } from 'src/components/filters';
import { ICombinationModel } from 'src/components/filters';
import { FormField2, IDynamicFormValue } from 'src/lib';
import { createAsyncThunk, createSlice, PayloadAction } from '@reduxjs/toolkit';
import {
  CHECKBOX_VALUES,
  Header,
  ITableData,
  TypeOfTableData
} from '../pricing-simulator/types/generic-table.model';
import { filterColumnsForToggleView } from '../pricing-simulator/utils/column-utils';
import {
  archivedScenarios,
  deleteScenarios,
  finalizedScenarios,
  getScenarioTableData,
  unArchivedScenarios,
  unMarkFinalizedScenarios
} from './api/scenario-manager-api';
import { fetchFilterFields } from '../common/features';
import { SummaryStripModuleObject } from '../constants/constant';
import { IProductComment } from '../planner_v2/types/ppg-sku-drawer.model';



// interface UpdateClusterSummaryNotePayload {
//   scenario_id: number;
//   noteData: IProductComment;
// }
/**
 * Api to get the list of created scenarios
 */
const getScenarioManagerTableData = createAsyncThunk(
  'getScenarioManagerTableData',
  async ({
    filterData,
    sourceId
  }: {
    filterData: { filter_inputs: any[] };
    sourceId: number;
  }) => {
    const response = await getScenarioTableData(filterData, sourceId);
    return response;
  }
);

/**
 * Api to delete the selected scenarios
 */
const deleteSelectedScenarios = createAsyncThunk(
  'deleteScenarios',
  async ({
    scenarioIds,
    sourceId
  }: {
    scenarioIds: number[];
    sourceId: number;
  }) => {
    const response = await deleteScenarios(
      { scenarios: scenarioIds },
      sourceId
    );
    return {
      scenarioIds,
      response: response.data
    };
  }
);

/**
 * Api to archived the selected scenarios
 */
const archivedSelectedScenarios = createAsyncThunk(
  'archiveScenarios',
  async ({
    scenarioIds,
    sourceId
  }: {
    scenarioIds: number[];
    sourceId: number;
  }) => {
    const response = await archivedScenarios(
      { scenarios: scenarioIds },
      sourceId
    );
    return {
      scenarioIds,
      response: response.data
    };
  }
);

/**
 * Api to archived the selected scenarios
 */
const unArchivedSelectedScenarios = createAsyncThunk(
  'unArchiveScenarios',
  async ({
    scenarioIds,
    sourceId
  }: {
    scenarioIds: number[];
    sourceId: number;
  }) => {
    const response = await unArchivedScenarios(
      { scenarios: scenarioIds },
      sourceId
    );
    return {
      scenarioIds,
      response: response.data
    };
  }
);

/**
 * Api to finalized the selected scenarios
 */
const finalizedSelectedScenarios = createAsyncThunk(
  'finalScenarios',
  async ({
    scenarioIds,
    sourceId
  }: {
    scenarioIds: number[];
    sourceId: number;
  }) => {
    const response = await finalizedScenarios(
      { scenarios: scenarioIds },
      sourceId
    );
    return {
      scenarioIds,
      response: response.data
    };
  }
);

/**
 * Api to unMark finalized  scenarios
 */
const unMarkSelectedFinalizedScenarios = createAsyncThunk(
  'unMarkSelectedFinalizedScenarios',
  async ({
    scenarioIds,
    sourceId
  }: {
    scenarioIds: number[];
    sourceId: number;
  }) => {
    const response = await unMarkFinalizedScenarios(
      { scenarios: scenarioIds },
      sourceId
    );
    return {
      scenarioIds,
      response: response.data
    };
  }
);

/**
 * Api to set Note in scenarios
 */
// scenario-manager-slice-async-thunks.ts
import { addComment } from '../planner_v2/api/planner-api';

export const addScenarioManagerComment = createAsyncThunk(
  'scenarioManager/addComment',
  async (
    {
     
      sourceId,
      moduleId,
      scenarioId,
      comment_text,
      filter_inputs = [],
      is_scenario_level = true,
      
    }: {
      
      sourceId: number;
      moduleId?: number;
      scenarioId: number;
      comment_text: string;
      filter_inputs?: IFilterObj[];
      is_scenario_level?: boolean; 
    },
    thunkAPI
  ) => {
    const response = await addComment(
      {
        comment_text,
        filter_inputs,
        is_scenario_level,
      },
      sourceId,
      moduleId,
      scenarioId,
      
      
    );
    return response.data;
  }
);

interface IScenarioManagerState {
  // Will use when the get scenario API is called.
  fetchingTableData: boolean;
  // It will contain the details of created scenario
  scenarioManagerTableData?: ITableData;
  inputCols: Header[];
  // Use to store the value of the checkboxes that are selected.
  activeCheckboxValues: CHECKBOX_VALUES[];
  // Store the value of the search input box.
  searchInputVal: string;
  // Will be used when the get scenario has been deleted.
  isDeletingScenario: boolean;
  // Will be used when the get scenario has been finalized.
  isFinalizingScenario: boolean;
  // Will be used when the get scenario has been archived.
  isArchivingScenario: boolean;
  // Will be used when the get scenario has been un archived.
  isUnArchivingScenario: boolean;
  // Variables for global filters
  globalFilterFormFields: FormField2[];
  globalFilterInitialValues: IDynamicFormValue;
  globalFilterValue: IDynamicFormValue;
  globalFilterCombinations: ICombinationModel[];
  isGlobalFiltersFetched: boolean;
  openShareScenarioDialog: boolean;
  scenarioToShare: { scenario_id?: number; scenario_name?: string };
}

const initialState: IScenarioManagerState = {
  fetchingTableData: false,
  activeCheckboxValues: [CHECKBOX_VALUES.IS_ACTIVE_FINALIZED],
  isUnArchivingScenario: false,
  searchInputVal: '',
  inputCols: [],
  isDeletingScenario: false,
  isFinalizingScenario: false,
  isArchivingScenario: false,
  scenarioManagerTableData: {
    legend: { metadata: [] },
    ownKPIColumnMetadata: {
      inputCols: [],
      resultCols: []
    },
    retailerKPIColumnMetadata: {
      inputCols: [],
      resultCols: []
    },
    metadata: [],
    show_edited: { enabled: false, label: '' },
    row: [],
    toggle: {
      metadata: [],
      data: {}
    },
    output_toggle: {
      metadata: [],
      data: {}
    },
    summary_strip: {
      metadata: [],
      data: {
        internal_dt: 0,
        external_dt: 0,
        renovation: SummaryStripModuleObject,
        pricing: SummaryStripModuleObject,
        delist: SummaryStripModuleObject,
        distribution: SummaryStripModuleObject,
        innovation_table: SummaryStripModuleObject
      }
    },
    footer: {
      metadata: {
        enabled: false,
        label: ''
      },
      row: []
    },
    header: []
  },
  globalFilterFormFields: [],
  globalFilterInitialValues: {},
  globalFilterValue: {},
  globalFilterCombinations: [],
  isGlobalFiltersFetched: false,
  openShareScenarioDialog: false,
  scenarioToShare: null,
};

const scenarioManagerSlice = createSlice({
  name: 'scenario-manager',
  initialState,
  reducers: {
    toggleShareScenarioDialogVisibility(
      state,
      action: PayloadAction<{
        visibility: boolean;
        scenario: { [key: string]: string | number };
      }>
    ) {
      state.openShareScenarioDialog = action.payload.visibility;
      state.scenarioToShare = action.payload.scenario;
    },
      updateScenarioManagerNote: (
        state, 
        action: PayloadAction<{
          scenario_id:number;
          noteData:IProductComment;
        }>) => {
        const { scenario_id, noteData } = action.payload;
        
        // Find and update the scenario in the row array
        if (state.scenarioManagerTableData?.row) {
          state.scenarioManagerTableData.row = state.scenarioManagerTableData.row.map((row: any) => {
            if (row.parent?.data?.scenario_id === scenario_id) {
              return {
                ...row,
                parent: {
                  ...row.parent,
                  data: {
                    ...row.parent.data,
                    note: noteData
                  }
                }
              };
            }
            return row;
          });
        }
      }
  },
  extraReducers: (builder) =>
    builder
      .addCase(getScenarioManagerTableData.pending, (state) => {
        state.fetchingTableData = true;
      })
      .addCase(getScenarioManagerTableData.fulfilled, (state, action) => {
        state.activeCheckboxValues = [CHECKBOX_VALUES.IS_ACTIVE_FINALIZED];
        state.fetchingTableData = false;
        state.scenarioManagerTableData = action.payload,

        state.inputCols = filterColumnsForToggleView(
          [
            TypeOfTableData.DISPLAY,
            TypeOfTableData.INPUT,
            TypeOfTableData.ACTION
          ],
          action.payload.header,
          ''
        );
      })
      .addCase(getScenarioManagerTableData.rejected, (state) => {
        state.fetchingTableData = false;
      })
      .addCase(deleteSelectedScenarios.pending, (state) => {
        state.isDeletingScenario = false;
      })
      .addCase(deleteSelectedScenarios.fulfilled, (state, action) => {
        state.isDeletingScenario = true;
        const selectedRowIds = action.payload.scenarioIds;
        state.scenarioManagerTableData.row =
          state.scenarioManagerTableData.row.filter(
            (row) => !selectedRowIds.includes(Number(row.parent.data.scenario_id))
          );
      })
      .addCase(deleteSelectedScenarios.rejected, (state) => {
        state.isDeletingScenario = false;
      })
      .addCase(archivedSelectedScenarios.pending, (state) => {
        state.isArchivingScenario = false;
      })
      .addCase(archivedSelectedScenarios.fulfilled, (state, action) => {
        state.isArchivingScenario = true;
        const selectedScenarioIds = action.payload.scenarioIds;
        state.scenarioManagerTableData.row
          .filter((row) =>
            selectedScenarioIds.includes(Number(row.parent.data.scenario_id))
          )
          .forEach((rowData) => {
            // eslint-disable-next-line no-param-reassign
            rowData.parent.data.is_archived = true;
            // eslint-disable-next-line no-param-reassign
            rowData.parent.data.is_active = false;
          });
      })
      .addCase(archivedSelectedScenarios.rejected, (state) => {
        state.isArchivingScenario = false;
      })
      .addCase(finalizedSelectedScenarios.pending, (state) => {
        state.isFinalizingScenario = false;
      })
      .addCase(finalizedSelectedScenarios.fulfilled, (state, action) => {
        state.isFinalizingScenario = true;
        const selectedScenarioIds = action.payload.scenarioIds;
        state.scenarioManagerTableData.row
          .filter((row) =>
            selectedScenarioIds.includes(Number(row.parent.data.scenario_id))
          )
          .forEach((rowData) => {
            // eslint-disable-next-line no-param-reassign
            rowData.parent.data.is_finalized = true;
          });
      })
      .addCase(finalizedSelectedScenarios.rejected, (state) => {
        state.isFinalizingScenario = false;
      })
      .addCase(unMarkSelectedFinalizedScenarios.pending, (state) => {
        state.isFinalizingScenario = false;
      })
      .addCase(unMarkSelectedFinalizedScenarios.fulfilled, (state, action) => {
        state.isFinalizingScenario = true;
        const selectedScenarioIds = action.payload.scenarioIds;
        state.scenarioManagerTableData.row
          .filter((row) =>
            selectedScenarioIds.includes(Number(row.parent.data.scenario_id))
          )
          .forEach((rowData) => {
            // eslint-disable-next-line no-param-reassign
            rowData.parent.data.is_finalized = false;
          });
      })
      .addCase(unMarkSelectedFinalizedScenarios.rejected, (state) => {
        state.isFinalizingScenario = false;
      })
      /**
       * Case for global filter api
       */
      .addCase(fetchFilterFields.pending, (state) => {
        state.isGlobalFiltersFetched = false;
      })
      .addCase(fetchFilterFields.rejected, (state) => {
        state.isGlobalFiltersFetched = false;
      })
      .addCase(fetchFilterFields.fulfilled, (state, action) => {
        state.isGlobalFiltersFetched = true;
        const { combinations, formFieldsWithUpdatedOptions, newFormValues } =
          action.payload;
        state.globalFilterFormFields = formFieldsWithUpdatedOptions;
        state.globalFilterInitialValues = newFormValues;
        state.globalFilterValue = newFormValues;
        state.globalFilterCombinations = combinations;
      })
      .addCase(unArchivedSelectedScenarios.pending, (state) => {
        state.isUnArchivingScenario = false;
      })
      .addCase(unArchivedSelectedScenarios.fulfilled, (state, action) => {
        state.isArchivingScenario = true;
        const selectedScenarioIds = action.payload.scenarioIds;
        state.scenarioManagerTableData.row
          .filter((row) =>
            selectedScenarioIds.includes(Number(row.parent.data.scenario_id))
          )
          .forEach((rowData) => {
            // eslint-disable-next-line no-param-reassign
            rowData.parent.data.is_archived = false;
            // eslint-disable-next-line no-param-reassign
            rowData.parent.data.is_active = true;
          });
      })
      .addCase(unArchivedSelectedScenarios.rejected, (state) => {
        state.isUnArchivingScenario = false;
      })
      .addCase(addScenarioManagerComment.fulfilled, (state, action) => {
        const scenarioId = action.meta.arg.scenarioId;
      const payload = action.payload;
      const scenario = state.scenarioManagerTableData.row.find(
        (row) => Number(row.parent.data.scenario_id) === scenarioId
      );
    })
});

// eslint-disable-next-line no-empty-pattern
export const { toggleShareScenarioDialogVisibility, 
  updateScenarioManagerNote } =
  scenarioManagerSlice.actions;

export {
  getScenarioManagerTableData,
  deleteSelectedScenarios,
  archivedSelectedScenarios,
  unArchivedSelectedScenarios,
  finalizedSelectedScenarios,
  unMarkSelectedFinalizedScenarios,
  
};

export default scenarioManagerSlice;
